import { useCallback } from 'react';
import { identify, isInitialized } from '@zillow/universal-analytics';
import { useZillowSession } from 'src/services/auth/session/hooks';
import { isServerSide } from 'src/utils/validators/isServerSide';
import { initializeClickstream } from '../initializeClickstream';
import { getEncodedZUIDFromCookie } from './utils/getEncodedZUIDFromCookie';

export const useClickstreamAnalytics = (): (() => void) => {
    const { session } = useZillowSession();
    const { encoded_zuid } = session ?? {};

    const triggerAnalytics = useCallback(() => {
        const cookieEncodedZUID = getEncodedZUIDFromCookie();
        if (isServerSide()) {
            return;
        }
        if (!isInitialized()) {
            initializeClickstream();
        }
        if (cookieEncodedZUID === encoded_zuid) {
            return;
        }
        if (!encoded_zuid) {
            return;
        }
        identify(encoded_zuid);
    }, [encoded_zuid]);

    return triggerAnalytics;
};
